import React, { useContext, useState } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { AuthContext } from "../../../../../auth-context";
import { DashboardContext } from "../../../dashboard-context";
import { Row, Action } from "../../../../../components/action-button";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import { deleteSurveyAssignment, loadProfile } from "../../../../../api";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableHeadRow,
  TableBodyRow,
  HeadCell,
  DataCell,
  BulkEdit,
  BulkAction,
  WhiteCheckbox,
} from "../../../../../components/table";
import Modal from "../../../../../components/modal";

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`;

const TableTitle = styled.h2`
  display: flex;
  align-items: center;
  margin: 24px auto;
  color: #555;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 500;

  button {
    margin-left: 16px;
  }
`;

const CustomTableContainer = styled(TableContainer)`
  height: 600px;
`;

const AssignedClients = (props) => {
  const { user, updateUser } = useContext(AuthContext);
  const { openSnackbar } = useContext(DashboardContext);
  const [showSelect, setShowSelect] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);

  const handleDelete = (accountID) => {
    deleteSurveyAssignment(user.id, [accountID])
      .then((res) => {
        openSnackbar("Client removed from check-in form", false);
        loadProfile(user.id).then((res) => {
          updateUser(res.data.profile);
        });
      })
      .catch((err) => {
        openSnackbar("Error removing client from check-in form", true);
      });
  };

  const handleDeleteBulk = () => {
    deleteSurveyAssignment(user.id, selectedClients)
      .then((res) => {
        openSnackbar("Clients removed from check-in form", false);
        loadProfile(user.id).then((res) => {
          updateUser(res.data.profile);
        });
      })
      .catch((err) => {
        openSnackbar("Error removing client from check-in form", true);
      });
  };

  const handleSelect = (user_id) => {
    if (selectedClients.includes(user_id)) {
      setSelectedClients(selectedClients.filter((id) => id !== user_id));
    } else {
      setSelectedClients([...selectedClients, user_id]);
    }
  };

  const handleSelectAll = () => {
    const allUsers = [];
    const assignedClients = user.accounts.filter((account) => {
      return account?.survey?.assigned_survey_id === props.surveyID;
    });
    assignedClients.forEach((entry) => {
      allUsers.push(entry.id);
    });

    if (selectedClients.length === allUsers.length) {
      setSelectedClients([]);
    } else {
      setSelectedClients(allUsers);
    }
  };

  const assignedClients = user.accounts.filter((account) => {
    return account?.survey?.assigned_survey_id === props.surveyID;
  });

  return (
    <Modal
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth="lg"
      hideAction={true}
    >
      <Container>
        <TableTitle>
          Clients assigned to this check-in form
          <BulkEdit
            highlight={showSelect}
            onClick={() => {
              setShowSelect(!showSelect);
              setSelectedClients([]);
            }}
          >
            Bulk Edit
          </BulkEdit>
          {showSelect && (
            <BulkAction
              onClick={handleDeleteBulk}
            >
              Delete check-in form assignment(s)
            </BulkAction>
          )}
        </TableTitle>
        <CustomTableContainer>
          <Table>
            <TableHead>
              <TableHeadRow>
                {showSelect && (
                  <HeadCell>
                    <WhiteCheckbox
                      style={{ color: "#FFF" }}
                      checked={selectedClients.length === assignedClients.length}
                      onChange={handleSelectAll}
                      inputProps={{ "aria-label": "checkbox" }}
                    />
                  </HeadCell>
                )}
                <HeadCell>Email Address</HeadCell>
                <HeadCell>Name</HeadCell>
                <HeadCell>Actions</HeadCell>
              </TableHeadRow>
            </TableHead>
            <TableBody>
              {assignedClients.map((client) => {
                return (
                  <TableBodyRow key={client.id}>
                    {showSelect && (
                      <DataCell>
                        <WhiteCheckbox
                          checked={selectedClients.includes(client.id)}
                          onChange={() => handleSelect(client.id)}
                          inputProps={{ "aria-label": "checkbox" }}
                        />
                      </DataCell>
                    )}
                    <DataCell>{client.email_address}</DataCell>
                    <DataCell>{client.name}</DataCell>
                    <DataCell>
                      <Action
                        icon={<DeleteIcon />}
                        iconColor="#da0f0f"
                        text="Delete"
                        onClick={() => handleDelete(client.id)}
                      />
                    </DataCell>
                  </TableBodyRow>
                );
              })}
            </TableBody>
          </Table>
        </CustomTableContainer>
      </Container>
    </Modal>
  );
};

export default withRouter(AssignedClients);
